import React from 'react';
import { CustomButton, CustomModalWithoutButton } from '@/components';

interface AiTestCallModalProps {
  modalOpen: boolean;
  setModalOpen: (open: boolean) => void;
  phone: string;
  handleAiCallConfirm: () => void;
}

/**
 * Modal for initiating an AI test call
 *
 * @param modalOpen - Whether the modal is visible
 * @param setModalOpen - Function to control modal visibility
 * @param phone - Phone number to call
 * @param handleAiCallConfirm - Function to execute when user confirms the call
 */
const AiTestCallModal: React.FC<AiTestCallModalProps> = ({
  modalOpen,
  setModalOpen,
  phone,
  handleAiCallConfirm,
}) => {
  return (
    <>
      <CustomModalWithoutButton
        modalOpen={modalOpen}
        fontSize='20px'
        setModalOpen={setModalOpen}
        modalTitle='Test call'
        modalText={`The Zoomlogi AI assistant will call you at ${phone} — the number from your profile.`}
        modalSize={480}
      >
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <CustomButton
            text='Cancel'
            bgColor='var(--surface-container)'
            color='var(--text-primary)'
            boxShadow={'none'}
            fontSize='14px'
            fontWeight='600'
            height='36px'
            padding='0 16px'
            borderRadius='8px'
            onClick={() => setModalOpen(false)}
          />
          <CustomButton
            text='Call me now'
            bgColor='#000'
            color='#fff'
            boxShadow={'none'}
            fontSize='14px'
            fontWeight='600'
            height='36px'
            padding='0 16px'
            borderRadius='8px'
            onClick={() => {
              handleAiCallConfirm();
            }}
          />
        </div>
      </CustomModalWithoutButton>
    </>
  );
};

export default AiTestCallModal;
